<template>
  <div class="test" ref="test">
    <div ref="modal12" :style="{ width: imgW + 200 + 'px' }" class="md-modal md-effect-12" id="modal-12">
      <div class="md-content">
        <img v-if="showDetailType <= 1" src="" :style="{ width: imgW + 'px' }" />
        <video controls="controls" autoplay v-else-if="showDetailType > 1" src="" :style="{ width: imgW + 'px' }" />
      </div>
    </div>
    <div>
      <div ref="infoDetail" class="infoDetail">
        <warn1-tiny class="warn1-Tiny" :data="detailData" :typeId="detailID"></warn1-tiny>
      </div>
      <div ref="infoHistory" class="infoHistory">
        <div ref="chart" class="historyChart"></div>
      </div>
    </div>
    <div class="processComponent">
      <div class="everyComponent">
        <ul>
          <template v-for="(item, i) in cachePointList" v-bind:key="i">
            <li v-show="false" :id="'playPos-' + i" v-if="
                winPos[i + cacheList.length] &&
                winPos[i + cacheList.length][0] &&
                winPos[i + cacheList.length][3] &&
                item['status'] == 'play'
              " :key="i" class="ComponentTip_" :style="{
                left: winPos[i + cacheList.length][0] / prew - 29 + 'px',
                bottom: winPos[i + cacheList.length][3] / prew - 32 + 'px',
              }">
              <div v-if="!item.type">
                <img class="red" src="./img/red.png" />
              </div>
              <div v-else-if="item.type">
                <img class="green" src="./img/green.png" />
              </div>
            </li>
          </template>
        </ul>
        <ul>
          <template v-for="(item, i) in cacheList">
            <li :id="'playTip-' + i" v-if="
                winPos[i] &&
                winPos[i][0] &&
                winPos[i][3] &&
                item['status'] == 'play'
              " :key="i" class="ComponentTip" :style="{
                left: winPos[i][0] / prew - 255 + 'px',
                bottom: winPos[i][3] / prew - 160 + 'px',
              }">
              <div class="warn_block" v-if="
                  item.typeName == '空气质量微站' ||
                  (item.typeName && item.typeName.indexOf('CEMS') != -1)
                ">
                <div class="warn_innerBlock" @click="openDiv()" @mouseenter="stopWarning(i)" @mouseleave="restoreWarning(i)">
                  <warn1 class="warn1" :data="item.data" :typeId="item.typeId"></warn1>
                </div>
                <img class="img2" src="./img/4.png" alt="" />
              </div>
              <div class="warn_block" v-else-if="item.typeName && item.typeName.indexOf('VDM') != -1">
                <div class="warn_innerBlock" @click="openDiv()" @mouseenter="stopWarning(i)" @mouseleave="restoreWarning(i)">
                  <warn2 class="warn2" :data="item.data"></warn2>
                </div>
                <img class="img2" src="./img/4.png" alt="" />
              </div>
              <div class="warn_block" v-else-if="item.typeId == '同步率'">
                <div class="warn_innerBlock" @click="openDiv()" @mouseenter="stopWarning(i)" @mouseleave="restoreWarning(i)">
                  <warn3 class="warn3" :data="item.data"></warn3>
                </div>
                <img class="img2" src="./img/4.png" alt="" />
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapGetters } from "vuex";
import Warn1 from "./warn1.vue";
import Warn2 from "./warn2.vue";
import Warn3 from "./warn3.vue";
import Warn1Tiny from "./warn1_tiny.vue";

import getOpt from "./js/chartOpt.js";
import { unwarp } from "@/utils/tools.js";

import { unref } from "vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Warn1, Warn2, Warn3, Warn1Tiny },
  inject: ["getEventData"],
  data() {
    //这里存放数据
    return {
      imgH: bmeConfig.INIT_HEIGHT * 0.6,
      imgW: bmeConfig.INIT_WIDTH * 0.5,
      showDetailType: 0,
      customerId: this.$store.state.customerId,
      fadeInTimer: {},
      fadeOutTimer: {},

      cacheList: [
        {
          tipID: "playTip-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-1",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-2",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-3",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
      ],
      cachePointList: [
        {
          tipID: "playPos-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-1",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-2",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-3",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-4",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-5",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-6",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-7",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-8",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-9",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
      ],
      playList: [],
      pointList: [],
      winPos: [], //排放源点的定位
      isStop: false,
      stopTime: 0,
      stopIndex: "",
      countIndex: 0,
      detailData: {},
      detailID: "",
      otherTimer: "",
      valueHistory: [],
      needDetail: false,
      counter: 0,
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapState({ prew: "scaleValue" }),
  },
  //监控data中的数据变化
  watch: {
    getEventData: {
      handler(newVal, oldVal) {
        let tmpObj = unref(newVal);
        let workTicketNo = tmpObj["workTicketNo"];
        this.getSinglePlayEvent(workTicketNo);
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.altitude =
      bmeConfig.altitude || bmeConfig.altitude === 0 ? bmeConfig.altitude : 50;
    this.flyAltitude = this.altitude < 150 ? 150 : this.altitude;

    //this.tipList();
    let total = this.cacheList.length + this.cachePointList.length;
    for (let i = 0; i < total; i++) {
      this.winPos.push([]);
    }
    this.getData();
    this.renderPlay();
    this.flyToFixedPoint();

    let that = this;
    $(this.$refs.test).unbind("click");
    $(this.$refs.test).bind("click", function () {
      that.closeDiv();
    });
  },
  activated() {
    this.dataReset();
    let total = this.cacheList.length + this.cachePointList.length;
    for (let i = 0; i < total; i++) {
      this.winPos.push([]);
    }
    this.getData();
    this.renderPlay();
    this.flyToFixedPoint();

    let that = this;
    $(this.$refs.test).unbind("click");
    $(this.$refs.test).bind("click", function () {
      that.closeDiv();
    });
  }, //如果页面有keep-alive缓存功能，这个函数会触发
  deactivated() {
    clearTimeout(this.renderTimer);
    clearTimeout(this.getDataTimer);
    clearTimeout(this.flyToFixedTimer);

    this.dataReset();
    for (var i in this.fadeInTimer) {
      if (this.fadeInTimer[i]) {
        clearTimeout(this.fadeInTimer[i]);
      }
    }

    for (var i in this.fadeOutTimer) {
      if (this.fadeOutTimer[i]) {
        clearTimeout(this.fadeOutTimer[i]);
      }
    }
  },
  beforeUnmount() {
    clearTimeout(this.renderTimer);
    clearTimeout(this.getDataTimer);
    clearTimeout(this.flyToFixedTimer);

    this.dataReset();
    for (var i in this.fadeInTimer) {
      if (this.fadeInTimer[i]) {
        clearTimeout(this.fadeInTimer[i]);
      }
    }

    for (var i in this.fadeOutTimer) {
      if (this.fadeOutTimer[i]) {
        clearTimeout(this.fadeOutTimer[i]);
      }
    }
  },
  //方法集合
  methods: {
    dataReset() {
      this.cacheList = [
        {
          tipID: "playTip-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-1",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-2",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
        {
          tipID: "playTip-3",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          data: {},
        },
      ];
      this.cachePointList = [
        {
          tipID: "playPos-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-1",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-2",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-3",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-4",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-5",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-0",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-6",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-7",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-8",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
        {
          tipID: "playPos-9",
          lng: 0,
          lat: 0,
          status: "wait",
          type: 0,
          renderTime: 0,
        },
      ];
      this.playList = [];
      this.pointList = [];
      this.winPos = []; //排放源点的定位
      this.isStop = false;
      this.stopTime = 0;
      this.stopIndex = "";
      this.countIndex = 0;
    },
    //初始飞行
    flyToFixedPoint() {
      if (bmeConfig.mapType !== "3D") return;
      let that = this;
      if (that.flyToFixedTimer) {
        clearTimeout(this.flyToFixedTimer);
      }
      if (
        window.g_bme3dManager &&
        window.g_bme3dManager.earth &&
        window.g_bme3dManager.earth.camera
      ) {
        let view =
          mapViews[`mapViews_${that.customerId}`] &&
          mapViews[`mapViews_${that.customerId}`].dutyMod;
        if (view && view.length) {
          window.g_bme3dManager.earth.camera.flyTo(
            view[0],
            view[1],
            view[2],
            view[3]
          );
        }
      } else {
        that.flyToFixedTimer = setTimeout(function () {
          that.flyToFixedPoint();
        },500);
      }
    },
    openDiv() {
      let that = this;
      let randomNum = Math.ceil(Math.random() * 2);
      this.showDetailType = randomNum;
      setTimeout(function () {
        $(that.$refs.modal12).fadeIn(1000, function () {
          $(that.$refs.test).addClass("pointerEventAll");
        });
      }, 500);
    },
    closeDiv() {
      let that = this;
      $(this.$refs.modal12).fadeOut(500, function () {
        $(that.$refs.test).removeClass("pointerEventAll");
      });
    },
    stopWarning(n) {
      this.isStop = true;
      this.stopTime = new Date().getTime();
      this.stopIndex = n;
    },
    restoreWarning(n) {
      let that = this;
      this.isStop = false;
      if ($("#playTip-" + n).length > 0) {
        $("#playTip-" + n).fadeOut(2000, function () {
          that.cacheList[n]["status"] = "wait";
          that.renderPoint(
            that.cacheList[n]["lng"],
            that.cacheList[n]["lat"],
            window.g_bme3dManager.earth,
            that.cacheList[n]["type"]
          );
        });
      }
    },
    async getSinglePlayEvent(workTicketNo) {
      clearTimeout(this.renderTimer);
      clearTimeout(this.flyToFixedTimer);
      let that = this;
      let unionDetailUrl = CONFIG.requestName + this.$apiOpt.unionDetail;
      let data = await this.$apiUtils.get(unionDetailUrl, {
        workTicketNo: workTicketNo,
      });
      [data].forEach((_, i) => {
        let devicePos = {};
        _.isHistory = true;
        this.getDevicePos(_.deviceNo).then((res) => {
          devicePos = res;
          let obj = {
            type: _.handleState == 2 || _.handleState == 3 ? 1 : 0,
            lng: devicePos.longitude || 0,
            lat: devicePos.latitude || 0,
            height: bmeConfig.altitude,
            data: _,
            typeId: _.typeId,
            typeName: _.typeName,
            isHistory: true,
          };
          this.playList.unshift(obj);
          for (let j in this.cacheList) {
            if (this.cacheList[j]["status"] == "play") {
              $("#" + this.cacheList[j]["tipID"]).fadeOut(500, function () {
                that.cacheList[j]["status"] = "wait";
              });
            }
          }

          this.renderPlay();
          this.flyToFixedPoint();
        });
      });
    },
    async getPlayEvents() {
      let scroll = CONFIG.requestName + this.$apiOpt.scroll;
      let data = await this.$apiUtils.get(scroll, {
        customerId: this.customerId,
      });
      data.forEach((_, i) => {
        let devicePos = {};
        this.getDevicePos(_.deviceNo).then((res) => {
          devicePos = res;
          let obj = {
            type: _.handleState == 2 || _.handleState == 3 ? 1 : 0,
            lng: devicePos.longitude || 0,
            lat: devicePos.latitude || 0,
            height: bmeConfig.altitude,
            data: _,
            typeId: _.typeId,
            typeName: _.typeName,
          };
          this.playList.push(obj);
        });
      });
    },
    getPointEvents() {
      let typeIndex = Math.floor(Math.random() * 2);
      let obj = {
        type: typeIndex,
        lng: 118.5526416 + Math.random() * 2 * 0.01,
        lat: 39.9679961 + Math.random() * 2 * 0.01,
        height: bmeConfig.altitude,
      };
      if (this.pointList.length > 10) {
        this.pointList.push(obj);
      }
    },

    //循环加数据
    getData() {
      let that = this;
      that.getPlayEvents();
      // that.getPointEvents();
      if (this.getDataTimer) {
        clearTimeout(this.getDataTimer);
      }
      this.getDataTimer = setTimeout(function () {
        that.getData();
      }, 20000);
    },
    //画点
    drawPointTip(tipID, lng, lat, height, n, earth, warnType) {
      let that = this;
      let pin = earth.sceneTree.$refs[tipID];
      if (warnType === 0 || warnType === 1) {
        that.cachePointList[n]["type"] = 0;
      } else {
        that.cachePointList[n]["type"] = 1;
      }

      if (pin) {
        let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          height +
          "]";
        let pos1 = eval(pos);
        let pinCzm = pin.czmObject;
        pinCzm.position = pos1;
        let n_ = n + that.cacheList.length;
        XE.MVVM.track(this, "winPos." + n_, pinCzm, "winPos");
      } else {
        let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          height +
          "]";
        let pos1 = eval(pos);
        var tipListObj = {
          ref: tipID,
          czmObject: {
            name: tipID,
            xbsjType: "Pin",
            position: pos1,
            near: 300,
            show: false,
          },
        };
        earth.sceneTree.root.children.push(tipListObj);
        let pinCzm = earth.sceneTree.$refs[tipID].czmObject;
        let n_ = n + that.cacheList.length;
        XE.MVVM.track(this, "winPos." + n_, pinCzm, "winPos");
      }
      this.$forceUpdate();
    },
    //画弹窗
    drawTip(tipID, lng, lat, height, n, earth, infoObj) {
      let that = this;
      let pin = earth.sceneTree.$refs[tipID];
      //去掉随机状态
      // that.cacheList[n]["type"] = Math.floor(Math.random() * 4);

      let pinCzm;
      if (pin) {
        let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          height +
          "]";
        let pos1 = eval(pos);
        pinCzm = pin.czmObject;
        pinCzm.position = pos1;
        XE.MVVM.track(this, "winPos." + n, pinCzm, "winPos");
      } else {
        let pos =
          "[" +
          lng +
          "*Math.PI/180.0, " +
          lat +
          "*Math.PI/180.0," +
          height +
          "]";
        let pos1 = eval(pos);
        var tipListObj = {
          ref: tipID,
          czmObject: {
            name: tipID,
            xbsjType: "Pin",
            position: pos1,
            near: 300,
            show: false,
          },
        };
        earth.sceneTree.root.children.push(tipListObj);
        pinCzm = earth.sceneTree.$refs[tipID].czmObject;
        XE.MVVM.track(this, "winPos." + n, pinCzm, "winPos");
      }

      this.$forceUpdate();
      this.$nextTick(function () {
        let tmpNode = $("#" + tipID);
        let compontentBar = tmpNode.find(".warn_block").find(".popupBar");
        //tmpNode.fadeOut(0);
        let isLeft = false,
          isTop = false;

        let ltPos = that.getOffsetTLByBody(tmpNode.get(0));
        let innerPos = that.getOffsetTLByBody(compontentBar.get(0));
        let l = pinCzm._winPos[0] / this.prew;
        let b = pinCzm._winPos[3] / this.prew;

        let screenW = $(".components_container").outerWidth();
        let screenH = $(".components_container").outerHeight();
        tmpNode.removeClass("bottomLeft");
        tmpNode.removeClass("bottomRight");

        if (l > screenW / 2) {
          //that.countIndex++;
          //if (that.countIndex % 2 === 0) {
          //tmpNode.find(".warn_innerBlock").css("left", -tmpNode.outerWidth());
          //tmpNode.find(".warn_innerBlock").css("left", screenW * 0.2);
          tmpNode
            .find(".warn_innerBlock")
            .css("transformOrigin", "left bottom");
          tmpNode
            .find(".warn_innerBlock")
            .css("left", l - 30)
            .css("bottom", b);
          tmpNode
            .find(".warn_innerBlock")
            .css(
              "transform",
              "scale(0.1, 0.1) translate(0px, 0px) rotateY(90deg)"
            );
          isLeft = false;
        } else {
          //tmpNode.find(".warn_innerBlock").css("left", tmpNode.outerWidth());
          /*tmpNode
            .find(".warn_innerBlock")
            .css("left", screenW * 0.8 - tmpNode.outerWidth());*/
          //tmpNode.find(".warn_innerBlock").css("left", l).css("bottom", b);
          tmpNode
            .find(".warn_innerBlock")
            .css("transformOrigin", "left bottom");
          tmpNode
            .find(".warn_innerBlock")
            .css("left", l - 30)
            .css("bottom", b);
          tmpNode
            .find(".warn_innerBlock")
            .css(
              "transform",
              "scale(0.1, 0.1) translate(0px, 0px) rotateY(-90deg)"
            );
          isLeft = true;
        }

        //?????????
        //debugger;

        //debugger;

        /* if (ltPos.top < 0) {
          tmpNode
            .find(".warn_block")
            .css("marginBottom", ltPos.top - (tmpNode.outerHeight() * 3) / 2);
        } else if (ltPos.top + tmpNode.outerHeight() > screenH) {
          tmpNode
            .find(".warn_block")
            .css(
              "marginBottom",
              ltPos.top + tmpNode.outerHeight() - screenH + tmpNode.outerHeight() / 2
            );
        } else {
          tmpNode.find(".warn_block").css("marginBottom", -tmpNode.outerHeight() / 2);
        }*/

        /*tmpNode
          .find(".warn_innerBlock")
          .addClass(
            isLeft
              ? isTop
                ? "topLeft"
                : "bottomLeft"
              : isTop
              ? "topRight"
              : "bottomRight"
          );*/
        //tmpNode.find(".warn_innerBlock").css("transform", "scale(0.05)");
        //if (isLeft) {

        /*} else {
          tmpNode.find(".warn_innerBlock").css("transformOrigin", "right bottom");
        }*/
        tmpNode.fadeOut(0);

        if (this.fadeInTimer[tipID]) {
          clearTimeout(this.fadeInTimer[tipID]);

          if (this.fadeOutTimer[tipID]) {
            clearTimeout(this.fadeOutTimer[tipID]);
            this.isStop = false;
          }
        }
        this.fadeInTimer[tipID] = setTimeout(function () {
          tmpNode.fadeIn(2000, function () {
            if (that.fadeOutTimer[tipID]) {
              clearTimeout(that.fadeOutTimer[tipID]);
            }

            that.fadeOutTimer[tipID] = setTimeout(function () {
              if (!that.isStop || that.stopIndex !== n) {
                //镜头移近
                if (that.needDetail) {
                  try {
                    let flyArg = JSON.parse(
                      g_bme3dManager.earth.camera.toAllJSONStr()
                    );

                    const earth = window.g_bme3dManager.earth;

                    earth.camera.flyTo(
                      [
                        (lng * Math.PI) / 180.0,
                        (lat * Math.PI) / 180.0,
                        that.altitude + 12,
                      ],
                      that.flyAltitude,
                      flyArg.rotation,
                      3
                    );
                    let screenW = $(".components_container").outerWidth();
                    let screenH = $(".components_container").outerHeight();
                    $(that.$refs.infoDetail).fadeOut(0);
                    $(that.$refs.infoDetail).css(
                      "top",
                      screenH / 2 - 410 + "px"
                    );
                    $(that.$refs.infoDetail).css(
                      "left",
                      screenW / 2 - 430 / 2 + "px"
                    );
                    $(that.$refs.infoDetail)
                      .find(".warn1-Tiny")
                      .removeClass("warn1-large");
                    $(that.$refs.infoHistory).fadeOut(0);
                    $(that.$refs.infoHistory).css(
                      "top",
                      screenH / 2 + 300 * bmeConfig.scaleRate + "px"
                    );
                    $(that.$refs.infoHistory).css(
                      "left",
                      screenW / 2 + 100 + "px"
                    );
                    $(that.$refs.infoHistory).removeClass("infoHistory-large");
                    if (that.otherTimer) {
                      clearTimeout(that.otherTimer);
                    }
                    that.otherTimer = setTimeout(function () {
                      $(that.$refs.infoHistory).fadeIn(1000);
                      $(that.$refs.infoDetail).fadeIn(1000, function () {
                        $(that.$refs.infoDetail)
                          .find(".warn1-Tiny")
                          .addClass("warn1-large");
                        $(that.$refs.infoHistory).addClass("infoHistory-large");
                        if (that.otherTimer) {
                          clearTimeout(that.otherTimer);
                        }
                        that.otherTimer = setTimeout(function () {
                          $(that.$refs.infoDetail).fadeOut(1000);
                          $(that.$refs.infoHistory).fadeOut(1000);
                        }, 5500);
                      });
                      that.detailData = infoObj.data;
                      that.detailID = infoObj.typeId;
                      that.valueHistory = infoObj.data.valueHistory;
                      that.getRealityData();
                    }, 3500);
                  } catch (err) {
                    console.log(err);
                  }
                }

                tmpNode.fadeOut(2000, function () {
                  that.cacheList[n]["status"] = "wait";
                  that.renderPoint(lng, lat, earth, that.cacheList[n]["type"]);
                  that.isStop = false;
                });
              }
            }, 5000);
          });
          tmpNode
            .find(".warn_innerBlock")
            .addClass(
              isLeft
                ? isTop
                  ? "topLeft"
                  : "bottomLeft"
                : isTop
                ? "topRight"
                : "bottomRight"
            );

          //debugger;
          if (isLeft) {
            tmpNode
              .find(".warn_innerBlock")
              .css(
                "transform",
                "scale(1, 1) translate(" +
                  (bmeConfig.DIY_W * 2 + 100 - l) +
                  "px, " +
                  (b - screenH + 750 + 300) +
                  "px) rotateY(-360deg)"
              );
          } else {
            tmpNode
              .find(".warn_innerBlock")
              .css(
                "transform",
                "scale(1, 1) translate(" +
                  (screenW - bmeConfig.DIY_W * 2 - l - 500) +
                  "px, " +
                  (b - screenH + 750 + 300) +
                  "px) rotateY(360deg)"
              );
          }
        }, 1000);
      });
    },
    getRealityData() {
      let _this = this;
      let valueHistory = this.valueHistory;
      if (valueHistory && valueHistory.length > 0 && valueHistory[0]["dps"]) {
        let dps = valueHistory[0]["dps"];
        this.pmData = {
          xData: [],
          y1Data: [],
          y2Data: [],
        };
        for (let i in dps) {
          this.noData = false;
          this.pmData.xData.push(this.$moment(i * 1000).format("MM-DD hh:mm"));
          this.pmData.y1Data.push(parseFloat(dps[i].toFixed(2)));
          this.pmData.y2Data.push(0);
        }
        this.$nextTick(() => {
          if (!this.chart) {
            this.chart = echarts.init(this.$refs.chart);
          }
          let optionStr = getOpt(this.pmData, this.detailData.signalName);
          unwarp(this.chart).setOption(optionStr);
        });
      }
    },
    getOffsetTLByBody(el) {
      let offsetTop = 0,
        offsetLeft = 0;
      while (el && el.tagName !== "BODY") {
        offsetTop += el.offsetTop;
        offsetLeft += el.offsetLeft;
        el = el.offsetParent;
      }
      return {
        left: offsetLeft,
        top: offsetTop,
      };
    },
    renderPoint(lng, lat, earth, warnType) {
      let that = this;
      let checkPointIndex = that.checkCachePointAvailable();
      if (checkPointIndex >= 0) {
        let cachePointObj = that.cachePointList[checkPointIndex];
        cachePointObj["lng"] = lng;
        cachePointObj["lat"] = lat;
        cachePointObj["status"] = "play";
        cachePointObj["renderTime"] = new Date().getTime();
        //$("#" + cacheObj["tipID"]).hide();
        that.drawPointTip(
          cachePointObj["tipID"],
          cachePointObj["lng"],
          cachePointObj["lat"],
          bmeConfig.altitude,
          checkPointIndex,
          earth,
          warnType
        );
      } else {
        this.cachePointList = this.cachePointList.sort(function (a, b) {
          return a["renderTime"] - b["renderTime"];
        });
        let cachePointObj = that.cachePointList[0];
        cachePointObj["lng"] = lng;
        cachePointObj["lat"] = lat;
        cachePointObj["status"] = "play";
        //$("#" + cacheObj["tipID"]).hide();
        that.drawPointTip(
          cachePointObj["tipID"],
          cachePointObj["lng"],
          cachePointObj["lat"],
          bmeConfig.altitude,
          0,
          earth,
          warnType
        );
      }
    },
    renderPlay() {
      let that = this;
      that.counter++;
      if (
        that.playList.length > 0 &&
        window.g_bme3dManager &&
        window.g_bme3dManager.earth &&
        !this.isStop
      ) {
        let checkIndex = that.checkCacheAvailable();
        if (checkIndex >= 0) {
          if (that.playList.length > 0) {
            let obj = that.playList.shift();
            let cacheObj = that.cacheList[checkIndex];
            cacheObj["lng"] = obj["lng"];
            cacheObj["lat"] = obj["lat"];
            cacheObj["status"] = "play";
            cacheObj["data"] = obj["data"];
            cacheObj["type"] = obj["type"];
            cacheObj["typeId"] = obj["typeId"];
            cacheObj["typeName"] = obj["typeName"];
            //$("#" + cacheObj["tipID"]).hide();
            that.drawTip(
              cacheObj["tipID"],
              cacheObj["lng"],
              cacheObj["lat"],
              bmeConfig.altitude,
              checkIndex,
              g_bme3dManager.earth,
              obj
            );
          } else {
            let cacheObj = that.cacheList[checkIndex];
            that.drawTip(
              cacheObj["tipID"],
              cacheObj["lng"],
              cacheObj["lat"],
              bmeConfig.altitude,
              checkIndex,
              g_bme3dManager.earth,
              obj
            );
          }
        }
      }

      let allAvailible = true;
      this.cacheList.forEach((obj, n) => {
        if (obj.status != "wait") {
          allAvailible = false;
        }
      });
      let curTime = new Date().getTime();
      //停止大于10秒钟并且所有
      // console.log(
      //   "停止大于10秒钟并且所有",
      //   curTime - this.stopTime,
      //   allAvailible
      // );
      if (curTime - this.stopTime > 6000 && allAvailible) {
        this.isStop = false;
      }

      if (this.counter % 3 === 0) {
        this.needDetail = true;
      } else {
        this.needDetail = false;
      }

      let deltaTime = this.needDetail ? 20 : 8; //parseInt(Math.random() * 3 + 5);
      if (this.renderTimer) {
        clearTimeout(this.renderTimer);
      } else {
        deltaTime = 3;
      }
      this.renderTimer = setTimeout(function () {
        if (window.g_bme3dManager && window.g_bme3dManager.earth) {
          const earth = window.g_bme3dManager.earth;
          let view =
            mapViews[`mapViews_${that.customerId}`] &&
            mapViews[`mapViews_${that.customerId}`].dutyMod;
          if (view && view.length) {
            window.g_bme3dManager.earth.camera.flyTo(
              view[0],
              view[1],
              view[2],
              3
            );
          }
        }
        if (that.renderTimer) {
          clearTimeout(that.renderTimer);
        }
        that.renderTimer = setTimeout(function () {
          that.renderPlay();
        }, 3000);
        //that.renderPlay();
      }, deltaTime * 1000);
    },
    async getDevicePos(deviceNo) {
      let getDevice = CONFIG.requestName + this.$apiOpt.getDevice;
      let data = await this.$apiUtils.get(getDevice, {
        deviceNo: deviceNo,
      });
      let devicePos = {};
      if (data) {
        devicePos = {
          longitude: data.longitude || 0,
          latitude: data.latitude || 0,
        };
      } else {
        devicePos = {
          longitude: 0,
          latitude: 0,
        };
      }
      return devicePos;
    },
    checkCachePointAvailable() {
      let num = -1;
      try {
        this.cachePointList.forEach((obj, n) => {
          if (obj.status == "wait") {
            num = n;
            throw Error("有空闲");
          }
        });
      } catch (err) {
        console.log("有空闲");
      }
      return num;
    },
    checkCacheAvailable() {
      let num = -1;
      try {
        this.cacheList.forEach((obj, n) => {
          if (obj.status == "wait") {
            num = n;
            throw Error("有空闲");
          }
        });
      } catch (err) {
        // console.log("有空闲");
      }
      return num;
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.infoDetail {
  position: fixed;
  //top: 120px;
  //left: calc(50% - 215px);
  z-index: 999999;
  display: none;
}

.infoHistory {
  position: fixed;
  //top: calc(50% + 200px);
  //left: calc(50% + 100px);
  z-index: 999999;
  display: none;
  width: 600px;
  height: 250px;
  background: linear-gradient(45deg, rgba(0, 0, 0.8), rgba(0, 0, 0, 0.3));
  border-radius: 15px;
  transform-origin: top left;
  transform: scale(0.01);
}

.infoHistory-large {
  transform: scale(1) !important;
  transition: all 0.75s 0.25s linear;
}

.historyChart {
  position: relative;
  width: 100%;
  height: 100%;
}

.warn1-Tiny {
  transform: scale(0.01);
  transform-origin: bottom center;
}

.warn1-large {
  transform: scale(1) !important;
  transition: all 0.75s 0s linear;
}

.warn_innerBlock {
  position: fixed;
  transition: all 1.2s ease-out;
  width: 450px;
  height: 732px;
}

.warn_block {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 100%;
}
.md-modal {
  z-index: 10001;
}
.md-content {
  padding: 75px 100px;
  background: rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 10px 5px #ccc;
}
.pointerEventAll {
  pointer-events: all;
}
.test {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  //pointer-events: auto;
  overflow: hidden;
  .processComponent {
    .everyComponent {
      ul {
        width: 100%;
        height: 100%;
        pointer-events: auto;
        .ComponentTip_ {
          background-size: 100% 100%;
          width: 46px;
          height: 46px;
          position: absolute;
          pointer-events: auto;
          img {
            animation: twinkle 1.5s;
            animation-iteration-count: infinite;
            // transform-origin: top center;
            animation-timing-function: linear;
          }
          .green {
            width: 100%;
            position: absolute;
            bottom: 0px;
            position: absolute;
          }
          .red {
            width: 100%;
            position: absolute;
            bottom: 0px;
            position: absolute;
          }
        }
        .ComponentTip {
          // background:  url('./img/1.png') no-repeat;
          background-size: 100% 100%;
          //background: red;
          width: 500px;
          height: 320px;
          position: absolute;
          // pointer-events: auto;

          div {
            .img-title {
              width: 100%;
              position: absolute;
              bottom: 150px;
              z-index: 1;
              background: url(./img/xk.png) no-repeat left top;
              background: url(./img/sk.png) no-repeat left bottom;
            }
            .img2 {
              width: 100%;
              animation: circleScale 1.5s;
              animation-iteration-count: infinite;
              transform-origin: top center;
              animation-timing-function: linear;
              position: absolute;
              bottom: -400px;
              //left: 25%;
            }
            .img-Image {
              width: 100%;
              position: absolute;
              bottom: 100px;
            }
            .img-video {
              width: 100%;
              position: absolute;
              bottom: 100px;
            }
            .warn1 {
              width: 100%;
              position: absolute;
              bottom: 150px;
            }
            .warn2 {
              width: 100%;
              position: absolute;
              bottom: 100px;
            }
            .warn3 {
              width: 100%;
              position: absolute;
              bottom: 150px;
            }
            .green {
              width: 100%;
              transform: scale(0.1);
              position: absolute;
              bottom: -120px;
            }
            .red {
              width: 100%;
              transform: scale(0.1);
              position: absolute;
              bottom: -120px;
            }
          }
        }
      }
    }
  }
}
@keyframes circleScale {
  0% {
    transform: rotateX(105deg) scale(0.1);
  }
  // 50% {
  //   transform: translateY(110px) rotateX(105deg) scale(0.75);
  // }
  100% {
    transform: rotateX(105deg) scale(0.3);
  }
}

@keyframes twinkle {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

#mvideo {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
}
.ddd {
  width: 46px;
  height: 46px;
  background-color: skyblue;
  position: absolute;
}

.topLeft {
  transform-origin: top left;
  -webkit-transform-origin: top left;
}

.topRight {
  transform-origin: top right;
  -webkit-transform-origin: top right;
}

.bottomLeft {
  transform-origin: bottom left;
  -webkit-transform-origin: bottom left;
  //left: 750px !important;
  //bottom: 50px !important;
  //transform: scale(1, 1) translate(750px, 100px) !important;
  transition: all 2s;
  transition-delay: 1s;
  transition-timing-function: ease-in-out;
}

.bottomRight {
  transform-origin: bottom right;
  -webkit-transform-origin: bottom right;
  //left: calc(100% - 1150px) !important;
  //bottom: 50px !important;
  //transform: scale(1, 1) translate(calc(100% - 1150px), 100px) !important;
  transition: all 2s;
  transition-delay: 1s;
  transition-timing-function: ease-in-out;
}
</style>
